import { Component, OnInit, Output, EventEmitter } from "@angular/core";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";

import { ClientPlanningCreationService } from "../../_services/client-planning-creation.service";
import { ToastService } from "../../_services/toast.service";

@Component({
  selector: "app-client-planning-creation",
  templateUrl: "./client-planning-creation.component.html",
  styleUrls: ["./client-planning-creation.component.css"],
})
export class ClientPlanningCreationComponent implements OnInit {
  @Output() refresh: EventEmitter<boolean> = new EventEmitter<boolean>();

  private planning_token: string;

  private token_checking = true;
  private token_valid = false;
  private report_sent = false;

  private formError;
  private submitting = false;
  private planning = null;


  constructor(
    private service: ClientPlanningCreationService,
    private toast: ToastService,
    private route: ActivatedRoute
  ) {}


  ngOnInit() {
    // Get the Params..
    this.route.queryParams.subscribe((params) => {
      this.planning_token = params["token_new_planning"] || 1; // Get transport number Param
    });

    this.service.checkToken(this.planning_token).subscribe((response) => {
      if (response && response.id) {
        this.token_valid = true;
        this.planning = response;
        this.toast.success("Identification planning réussie",false,"Accès sécurisé");
      } else {
        this.toast.error("Échec d'identification planning",false,"Accès sécurisé");
      }
      this.token_checking = false;
    });
  }

  form = new FormGroup({
    details: new FormControl("", [Validators.required]),
  });

  onSubmit() {
    this.service
      .submit({ form: this.form.value, planning_token: this.planning_token }) // Sublmit the details
      .subscribe((response) => {
        if (response && response.id) {

          this.report_sent = true; // If the response is an Object with an ID, this means a success
          this.toast.success("Réponse envoyée au client",false,"Signalement");
        } else {
          this.toast.error("Erreur lors de la réponse",false,"Signalement");
        }
        this.submitting = false; // Disable the loading button apparition
        this.form.enable(); // Re Enable the Form
        this.form.reset(); // Reset It
        this.refresh.emit(true); // Emmit the refresh Event
      });
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/_components/client-planning-creation/client-planning-creation.component.ts